export default "__VITE_ASSET__DTHKCgUr__"